import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

type TreeItemIconSlotProps = {
  children: ReactNode;
  className?: string;
};

export function TreeItemIconSlot({
  children,
  className,
}: TreeItemIconSlotProps) {
  return (
    <div
      className={cn(
        'eye:flex eye:h-lh eye:shrink-0 eye:items-center',
        className,
      )}
    >
      {children}
    </div>
  );
}
